import queryString from 'query-string'
import { csrfRequest } from './helpers/request'
import { GENERIC_PASSWORD_RESET_CONFIRMATION_CODE } from '../../constants/error.codes'

export const submitPasswordResetConfirmation = data =>
  csrfRequest({
    url: `/users/password/recover/${data.token}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: queryString.stringify(data)
  })
    .then(response => {
      if (response.status === 204) {
        return Promise.resolve(response)
      } else if (response.status === 400) {
        return response.json().then(json => {
          return Promise.reject(new Error(json.code))
        })
      } else {
        return Promise.reject(
          new Error(GENERIC_PASSWORD_RESET_CONFIRMATION_CODE)
        )
      }
    })
    .catch(error => {
      throw error
    })
